import { StyleSheet } from 'aphrodite';
import { background, brandPrimary, grayIconFill, header, white } from '../../../web/styles/colors';
import { BreakPoints } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	card: {
		boxSizing: 'border-box',
		backgroundColor: white,
		borderRadius: 6,
		height: 170,
		margin: 8,
		padding: 16,
		position: 'relative',
		width: 284,
		boxShadow: `0 0 0 1px oklch(0.1448 0 0 / 10%)`,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	cardHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	container: {
		backgroundColor: background,
		paddingBottom: 60,
	},
	contentContainer: {
		maxWidth: 920,
		width: '100%',
	},
	cta: {
		':disabled': {
			opacity: 0.5,
		},
		':hover:disabled': {
			background: brandPrimary,
			cursor: 'default',
			textDecoration: 'none',
		},
		bottom: 26,
		// the admin preview has no global font reset, and font-family inheritance does not reach <button>
		fontFamily: "'Sora', sans-serif",
		position: 'absolute',
	},
	header: {
		boxShadow: '',
		justifyContent: 'center',
		paddingTop: 36,
		textAlign: 'center',
		minHeight: 'initial',
		paddingBottom: 24,
	},
	icon: {
		marginRight: 6,
		marginTop: 4,
	},
	instructions: {
		color: header,
		fontSize: 16,
		paddingRight: 100,
		paddingTop: 16,
		[BreakPoints.forMaxWidth(768)]: {
			paddingRight: 0,
		},
	},
	label: {
		position: 'relative',
		color: grayIconFill,
		display: 'flex',
		alignItems: 'flex-end',
		gap: 4,
		fontWeight: 'bold',
		fontSize: 12,
		':has(*) > svg': {
			width: 20,
			height: 20,
		},
	},
	mainContainer: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		// the real page gets Sora from global-styles.less's `*` reset; declared here so the admin preview matches
		fontFamily: "'Sora', sans-serif",
		':has(*) *': {
			boxSizing: 'border-box',
		},
	},
	meetingName: {
		color: brandPrimary,
		fontSize: 16,
		fontWeight: 'bold',
	},
	meetings: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		margin: 'auto',
		maxWidth: 600,
	},
});
